import { createRoutine } from 'redux-saga-routines';

export const toggleRequestBuilderRoutine = createRoutine('TOGGLE_REQUEST_BUILDER');

export const setReqPositionRoutine = createRoutine('SET_REQ_POSITION');

export const fetchReqBuilderContactsRoutine = createRoutine('FETCH_REQ_BUILDER_CONTACTS');
export const resetReqBuilderContactsRoutine = createRoutine('RESET_REQ_BUILDER_CONTACTS');
export const addReqBuilderCandidateRoutine = createRoutine('ADD_REQ_BUILDER_CANDIDATE');
export const removeReqBuilderCandidateRoutine = createRoutine('REMOVE_REQ_BUILDER_CANDIDATE');
export const changeReqCandidatesOwnerRoutine = createRoutine('CHANGE_REQ_CANDIDATES_OWNER');
export const updateSelectedCandidateRoutine = createRoutine('UPDATE_SELECTED_CANDIDATE');

export const changeRefCountersRoutine = createRoutine('CHANGE_REF_COUNTERS');
export const fetchLastRefCountersRoutine = createRoutine('FETCH_LAST_REF_COUNTERS');
export const disableRefCounterRoutine = createRoutine('DISABLE_REF_COUNTER');
export const setDisabledRefTypesRoutine = createRoutine('SET_DISABLED_REF_TYPES');
export const toggleAdvancedReqRoutine = createRoutine('TOGGLE_ADVANCED_REQ_ROUTINE');

export const fetchReqBuilderSurveysRoutine = createRoutine('FETCH_REQ_BUILDER_SURVEYS');
export const fetchPositionLastSurveyRoutine = createRoutine('FETCH_POSITION_LAST_SURVEY');
export const setReqSurveyRoutine = createRoutine('SET_REQ_SURVEY');

export const setSendSMSToAllRoutine = createRoutine('SET_SEND_SMS_TO_ALL');
export const setReviewReferencesEnabledRoutine = createRoutine('SET_REVIEW_REFERENCES_ENABLED');
export const changeMessageTextRoutine = createRoutine('CHANGE_MESSAGE_TEXT');
export const setEmailTemplateRoutine = createRoutine('SET_EMAIL_TEMPLATE');
export const createReqRefRoutine = createRoutine('CREATE_REQ_REF');

export const requestAdditionalReferencesRoutine = createRoutine('REQUEST_ADDITIONAL_REFERENCES');

export const fetchRefReqEmailTemplatesRoutine = createRoutine('FETCH_REF_REQ_EMAIL_TEMPLATES');

export const setRefReqReferencesRoutine = createRoutine('SET_REF_REQ_REFERENCES');
export const addRefReqReferenceRoutine = createRoutine('ADD_REF_REQ_REFERENCE');
export const updateRefReqReferenceRoutine = createRoutine('UPDATE_REF_REQ_REFERENCE');
export const removeRefReqReferenceRoutine = createRoutine('REMOVE_REF_REQ_REFERENCE');
